export { positionElements, Positioning } from './ng-positioning'
export { PositioningService, PositioningOptions } from './positioning.service';



// WEBPACK FOOTER //
// ./src/positioning/index.ts